module.exports = __webpack_public_path__ + "CLOSEFOLDER.png";